import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import inductionApi, { getInductionToken, clearInductionToken } from '../api/inductionAxios';
import StaffInductionForm from './StaffInductionForm';
import { T } from '../components/UI';

// The only page a temporary worker login can reach — loads their induction and renders the form
export default function InductionAccessForm() {
  const navigate = useNavigate();
  const [induction, setInduction] = useState(null);
  const [error,     setError]     = useState(null);

  useEffect(() => {
    if (!getInductionToken()) { navigate('/induction-access', { replace: true }); return; }
    inductionApi.get('/me')
      .then(({ data }) => setInduction(data.induction))
      .catch(err => {
        clearInductionToken();
        setError(err.response?.data?.message || 'Something went wrong. Please try signing in again.');
      });
  }, [navigate]);

  if (error) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'Inter,sans-serif', padding:'20px' }}>
      <div style={{ textAlign:'center', maxWidth:'360px' }}>
        <div style={{ width:'56px', height:'56px', borderRadius:'50%', background:'var(--red-bg)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
          <i className="ti ti-clock-off" style={{ fontSize:'26px', color:'var(--red)' }} aria-hidden="true"/>
        </div>
        <p style={{ color:'var(--text)', fontSize:'14px', marginBottom:'20px', lineHeight:1.5 }}>{error}</p>
        <button onClick={()=>navigate('/induction-access', { replace: true })} style={T.btnPrimary}>Back to sign in</button>
      </div>
    </div>
  );

  if (!induction) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--muted)' }}>
      <i className="ti ti-loader" style={{ fontSize:'24px', color:'var(--blue)' }} aria-hidden="true"/>
    </div>
  );

  return <StaffInductionForm workerMode existingData={induction} />;
}
